// Business details shown in the About section, Contact section, footer and legal pages.
export const COMPANY = {
  name: 'TCGSecret',
  legalName: 'TCGSecret', // registered name as in the KvK register
  email: 'info@tcgsecret.nl',
  kvk: '42169622',
  btw: 'NL005553306B54',
};

export const REGISTRATION_DETAILS = [
  { label: 'KvK', value: COMPANY.kvk },
  { label: 'BTW', value: COMPANY.btw },
];

// Shipping terms shown on the Shipping page and checked against Terms article 9. Prices in euros incl. VAT.
export const SHIPPING = {
  carrier: 'PostNL',
  cutoffTime: '15:00', // orders placed on a business day before this time ship the same day
  signatureFrom: 250, // orders of this amount or more are sent with signature on delivery
  rates: [
    { code: 'NL', name: { en: 'Netherlands', nl: 'Nederland' }, cost: 6.95, freeFrom: 150, deliveryDays: '1–2' },
    { code: 'BE', name: { en: 'Belgium', nl: 'België' }, cost: 9.95, freeFrom: 150, deliveryDays: '2–3' },
  ],
};

export const LEGAL_LAST_UPDATED = '2026-10-21';

/** Shipping cost for an order subtotal, or null when we don't ship to that country. */
export function getShippingCost(countryCode: string, subtotal: number): number | null {
  const rate = SHIPPING.rates.find((r) => r.code === countryCode);
  if (!rate) return null;
  return subtotal >= rate.freeFrom ? 0 : rate.cost;
}
